import React, { useState, useEffect, Fragment } from 'react'
import { Button, Card, Col, Container, Form, Modal, OverlayTrigger, Row, Tooltip} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { MdAccountBox, MdPayments, MdPeopleAlt, MdAccountBalance, MdMonetizationOn, MdLock} from "react-icons/md";
import { FaMoneyBillAlt, FaClipboardList } from "react-icons/fa";
import { GiLetterBomb } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { BsFillCalculatorFill } from "react-icons/bs";
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiDollarCircle } from "react-icons/bi";
import { FcDiploma1 } from "react-icons/fc";
import { MdOutlineAddchart } from "react-icons/md";
import { CarpetaDigitalComponent, SolicitudDescuentoComponent, TrazabilidadHitosComponent, ProvisionGastosComponent, IngresoRecobroComponent, DeclaracionPagoComponent } from 'reccol-caso-general';
import Bitacora from '../bitacora';
import { useNavigate } from 'react-router-dom';
import { getModalesConsulta } from '../../api/api-consultar-caso';

import { ConsultaContactoAseguradoComponent, ConsultaContactoImplicadoComponent, ConsultaProcesosJudicialesComponent, ConsultaMovimientosComponent,
  ConsultaGastosHonorariosComponent, ConsultaPagosEmitidosComponent, ConsultaTrazabilidadHitosComponent, ConsultaGestionEntreCiasComponent, VerInformeProfesionalComponent } from 'defcol-caso-general';

import DetalleCierre from '../gestion-defensa-cia/confirmar-cierre/components/detalle-cierre';
import { serviceGetSolicitudGestion, serviceGetSolicitudes } from '../../api/api-confirmar-cierre';
import ModalSolicitudesInforme from './modal-solicitudes-informes'
import { LoadingComponent} from 'recupero-comunes'

const MenuConsultas = ({origen, antecedentesCaso}) => {
  const [loading, setLoading]=useState(false)
  const queryState = JSON.parse(localStorage.getItem('query'))
  const history =useNavigate()
  const [solicitud, setSolicitud] = useState(null);
  const [showBitacora, setShowBitacora] = useState(false)
  const [showCarpeta, setShowCarpeta] = useState(false)
  const [showSolicitud, setShowSolicitud] = useState(false)
  const [showTraza, setShowTraza] = useState(false)
  const [showProvision, setShowProvision] = useState(false)
  const [showIngreso, setShowIngreso] = useState(false)
  const [showCompromisoPago, setShowCompromisoPago] = useState(false)
  const [showInformeProfesional, setShowInformeProfesional] = useState(false)

  const [informesProfesional, setInformesProfesional] = useState([]);
  
  const data_consulta = useSelector((state) => state.consultarCasosReducer)
  const { cfg_form33} = data_consulta
  const data_general = useSelector((state) => state.encargadoCompaniaReducer)
  const { llaves} = data_general
  
  const dispatch=useDispatch()
  
  const handleShowBitacora = () => setShowBitacora(true)
  const handleCloseBitacora= () => setShowBitacora(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)
  const handleCloseProvision= () => setShowProvision(false)
  const handleCloseIngreso= () => setShowIngreso(false)
  const handleCloseCompromisoPago= () => setShowCompromisoPago(false)
  const handleCloseInformeProfesional= () => setShowInformeProfesional(false)

  const handleCloseSolicitud = () => setShowSolicitud(false)
  const handleCloseTraza = () => setShowTraza(false)
  const handleShowSolicitud = () => setShowSolicitud(true)
  const handleShowTraza = () => setShowTraza(true)
  const handleShowProvision = () => setShowProvision(true)
  const handleShowIngreso = () => setShowIngreso(true)
  const handleShowCompromisoPago = () => setShowCompromisoPago(true)
  
  const handleShowInformeProfesional = () => {
    getSolicitudes();
    setShowInformeProfesional(true)
  }
  

  const [showContactoAsegurado, setShowContactoAsegurado] = useState(false);
  const handleShowContactoAsegurado = () => setShowContactoAsegurado(true)

  const [showContactoImplicado, setShowContactoImplicado] = useState(false);
  const handleShowContactoImplicado = () => setShowContactoImplicado(true)

  const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
  const handleShowProcesosJudiciales = () => setShowProcesosJudiciales(true)

  const [showMovimientos, setShowMovimientos] = useState(false);
  const handleShowMovimientos = () => setShowMovimientos(true)

  const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
  const handleShowGastosHonorarios = () => setShowGastosHonorarios(true)

  const [showPagosEmitidos, setShowPagosEmitidos] = useState(false)
  const handleShowPagosEmitidos= () => setShowPagosEmitidos(true)

  const [showTrazabilidadHitosDef, setShowTrazabilidadHitosDef] = useState(false);
  const handleShowTrazabilidadHitosDef = () => setShowTrazabilidadHitosDef(true)

  const [showDetalleCierre, setShowDetalleCierreDef] = useState(false);
  const handleShowDetalleCierreDef = () => setShowDetalleCierreDef(true)

  const [showGestionEntreCias, setShowGestionEntreCias] = useState(false);
  const handleShowGestionEntreCias = () => setShowGestionEntreCias(true)

  const [modalesConsulta, setModalesConsulta] = useState([])
  
  const handlersShow = new Map();
  //handlersShow.set("c-btn-1", handleShowContacto);
  handlersShow.set("c-btn-1", handleShowContactoImplicado);
  //handlersShow.set("c-btn-2", handleShowCIA);
  handlersShow.set("c-btn-2", handleShowGestionEntreCias);
  handlersShow.set("c-btn-3", handleShowSolicitud);
  //handlersShow.set("c-btn-4", handleShowAntecedentes);
  handlersShow.set("c-btn-4", handleShowProcesosJudiciales);
  //handlersShow.set("c-btn-5", handleShowProvision);
  handlersShow.set("c-btn-5", handleShowGastosHonorarios);
  handlersShow.set("c-btn-6", handleShowIngreso);
  //handlersShow.set("c-btn-7", handleShowTraza);
  handlersShow.set("c-btn-7", handleShowTrazabilidadHitosDef);
  
  handlersShow.set("c-btn-10", handleShowContactoAsegurado);
  handlersShow.set("c-btn-11", handleShowContactoImplicado);
  handlersShow.set("c-btn-12", handleShowGestionEntreCias);
  handlersShow.set("c-btn-13", handleShowProcesosJudiciales);
  handlersShow.set("c-btn-14", handleShowMovimientos);
  handlersShow.set("c-btn-15", handleShowGastosHonorarios);
  handlersShow.set("c-btn-16", handleShowPagosEmitidos);
  handlersShow.set("c-btn-17", handleShowTrazabilidadHitosDef);
  handlersShow.set("c-btn-18", handleShowDetalleCierreDef);

  handlersShow.set("c-btn-19", handleShowCompromisoPago);
  handlersShow.set("c-btn-20", handleShowInformeProfesional);

  const icons = new Map();
  icons.set("c-btn-1", <MdAccountBox size={35}/>);
  icons.set("c-btn-2", <GiLetterBomb size={35}/>);
  icons.set("c-btn-3", <BsFillCalculatorFill size={35}/>);
  icons.set("c-btn-4", <BsBank size={35}/>);
  icons.set("c-btn-5", <GiMoneyStack size={35}/>);
  icons.set("c-btn-6", <BiDollarCircle size={35}/>);
  icons.set("c-btn-7", <AiOutlineFileSearch size={35}/>);
  
  icons.set("c-btn-10", <MdAccountBox size={35}/>);
  icons.set("c-btn-11", <MdPeopleAlt size={35}/>);
  icons.set("c-btn-12", <GiLetterBomb size={35}/>);
  icons.set("c-btn-13", <MdAccountBalance size={35}/>);
  icons.set("c-btn-14", <MdMonetizationOn size={35}/>);
  icons.set("c-btn-15", <FaMoneyBillAlt size={35}/>);
  icons.set("c-btn-16", <MdPayments size={35}/>);
  icons.set("c-btn-17", <FaClipboardList size={35}/>);
  icons.set("c-btn-18", <MdLock size={35}/>);

  icons.set("c-btn-19", <FcDiploma1 size={35}/>);
  icons.set("c-btn-20", <MdOutlineAddchart size={35}/>);

  useEffect(() => {
      if (llaves) getSolicitudGestion();
  }, [llaves])

  const getSolicitudGestion = async () => {
    let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idImplicado: 0, grupoSolGestion: 246002 })).toString('base64');
    const response = await serviceGetSolicitudGestion(query);

    setSolicitud(response && response.length > 0 ? response[0] : null);
}
 
  useEffect(() => {

    if (llaves && antecedentesCaso) {

      const obtenerAntecedentesCaso = async () => {
        let query2 = Buffer.from(JSON.stringify({ tipoGestion: antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion })).toString('base64')
          const response2 = await getModalesConsulta(query2);
          
          if (response2) {
            setModalesConsulta(response2);
          } else {
            console.log("No se obtuvo Iconos modales!")
          } 
      }
      obtenerAntecedentesCaso();
    }
  }, [llaves, antecedentesCaso])

  const handleVolver = () => {    
    if (origen && origen == 'consulta360') { 
      setTimeout(()=> history('/consulta-gestion-360',{state:{queryState}}),10)      
    } else {
      setTimeout(()=> history('/area-busqueda-casos',{state:{queryState}}),10)      
    }
  } 
  const getSolicitudes = async () => {
      setLoading(true);   
      const query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso })).toString('base64');
      const response = await serviceGetSolicitudes(query);

      if (response && response.length > 0) {
        setInformesProfesional(response);             
      }
      setLoading(false);
  }

  return (
    <>
  <style type='text/css'>
    {`
    .cardHeader {
      background-color: #77789b;
      color: #FFFFFF;
    }
    .btn-botones {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;
      width:'40px';

    }
    .btn-botones:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }    
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    }   
    `} </style>
     <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />

    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={2}            
          />          
    </Modal>
    <Modal show={showProvision} onHide={handleCloseProvision} size="xl">              
        <ProvisionGastosComponent handleClose={handleCloseProvision} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}                
          />          
    </Modal>
    <Modal show={showIngreso} onHide={handleCloseIngreso} size="xl">      
        <IngresoRecobroComponent handleClose={handleCloseIngreso} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          />          
    </Modal>
    <Modal show={showSolicitud} onHide={handleCloseSolicitud} size='xl'>
        <SolicitudDescuentoComponent handleClose={handleCloseSolicitud} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
    </Modal>
    <Modal show={showTraza} onHide={handleCloseTraza} size='xl' >
        <TrazabilidadHitosComponent handleClose={handleCloseTraza} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
    </Modal>
    <Modal show={showCompromisoPago} onHide={handleCloseCompromisoPago} size="xl">      
        <DeclaracionPagoComponent handleClose={handleCloseCompromisoPago} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          />          
    </Modal>

    {/* DEFENSA */}
    <ConsultaContactoAseguradoComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showContactoAsegurado}
          setShowModal={setShowContactoAsegurado}
      />
      <ConsultaContactoImplicadoComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showContactoImplicado}
          setShowModal={setShowContactoImplicado}
      />
      <ConsultaProcesosJudicialesComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showProcesosJudiciales}
          setShowModal={setShowProcesosJudiciales}
      />
      <ConsultaMovimientosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          codClasCaso={antecedentesCaso && antecedentesCaso[0]?.CodClasificacionCaso}
          showModal={showMovimientos}
          setShowModal={setShowMovimientos}
      />
      <ConsultaGastosHonorariosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showGastosHonorarios}
          setShowModal={setShowGastosHonorarios}
      />
      <ConsultaPagosEmitidosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showPagosEmitidos}
          setShowModal={setShowPagosEmitidos}
      />
      <ConsultaTrazabilidadHitosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showTrazabilidadHitosDef}
          setShowModal={setShowTrazabilidadHitosDef}
      />
      <DetalleCierre
          showModal={showDetalleCierre}
          setShowModal={setShowDetalleCierreDef}
          implicado={0}
          solicitud={solicitud}
      />
      <ConsultaGestionEntreCiasComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showGestionEntreCias}
          setShowModal={setShowGestionEntreCias}
      />
      <ModalSolicitudesInforme
          idCaso={llaves?.idCaso}       
          solicitudes={informesProfesional}
          showModalSolicitudes={showInformeProfesional}
          handleCloseModalSolicitudes={handleCloseInformeProfesional}
      />
      <LoadingComponent show={loading}/>
      <Container>
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' ,textAlign:'center' }}
          >
            {cfg_form33? cfg_form33.cfg_form33['detalleconsulta-subtitle']:''}
          </Card.Header>
            <Container>
              {cfg_form33? (
                <div >
                  <Row className='d-flex mt-4' >
                    <Col style={{alignSelf:'start'}}>
                      {modalesConsulta && modalesConsulta?.map((modal, index) => {
                          return (                        
                              <OpenModalComponent
                                modal={modal} 
                                handleShow={handlersShow.get(modal.idBtn)}
                                icon={icons.get(modal.idBtn)}
                              />                          
                          )
                        })
                      }
                    </Col>
                    
                    {/*<Col style={{alignSelf:'start'}}>
                      
                      <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-ctotro']:''}</Tooltip>}>
                         <Button variant='outline-info' id="c-btn-1" className='mx-1' onClick={handleShowContacto}>
                           <MdAccountBox size={35}/>
                          </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-carta']:''}</Tooltip>}>
                         <Button id="c-btn-2" variant='outline-info' className='mx-1'  onClick={handleShowCIA}>
                           <GiLetterBomb size={35}/>
                          </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-dcto']:''}</Tooltip>}>
                          <Button id="c-btn-3"  variant='outline-info' className='mx-1'  onClick={handleShowSolicitud}>
                           <BsFillCalculatorFill size={35}  />
                          </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-antecjud']:''}</Tooltip>}>
                         <Button variant='outline-info' id="c-btn-4" className='mx-1'  onClick={handleShowAntecedentes}>
                           <BsBank size={35}/>
                          </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-gastos']:''}</Tooltip>}> 
                         <Button id="c-btn-5" variant='outline-info' className='mx-1'  onClick={handleShowProvision} >
                           <GiMoneyStack size={35}/>
                          </Button>
                          </OverlayTrigger>

                         <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-recobros']:''}</Tooltip>}>  
                          <Button id="c-btn-6"  variant='outline-info' className='mx-1'  onClick={handleShowIngreso}>
                           <BiDollarCircle size={35}/>
                          </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{cfg_form33? cfg_form33.cfg_form33['detalleconsulta-gestion-hitos']:''}</Tooltip>}>  
                          <Button id="c-btn-7"  variant='outline-info' className='mx-1'  onClick={handleShowTraza} >
                           <AiOutlineFileSearch size={35}/>
                          </Button>
                          </OverlayTrigger>
                        
                    </Col>*/}
                  </Row>
                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                  <Container>
                    <Row className='mt-2'>                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={handleVolver} >
                                {cfg_form33 && cfg_form33.cfg_form33["detalleconsulta-btn-volver"]}
                            </Button>
                            <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
                                {cfg_form33 && cfg_form33.cfg_form33["detalleconsulta-btn-bitacora"]}
                            </Button>
                            <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                                {cfg_form33 && cfg_form33.cfg_form33["detalleconsulta-btn-carpeta"]}
                            </Button>                        
                            
                        </Col>
                    </Row>
                </Container>
                </div>
              ) : null}
            </Container>
        </Card>
        </Container>
        
     </>
  )
}
export default MenuConsultas

const OpenModalComponent=({modal, handleShow, icon})=>{  
  return (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{modal.toltip}</Tooltip>}>
      <Button variant='outline-info' id={modal.id} className='mx-1' onClick={handleShow}>
        {icon}
      </Button>
    </OverlayTrigger>
  )
}